import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles/global.css';
import './styles/staff-console.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('index.html is missing the #root container');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
